export const parentContainerCommonStyles = (FOUNDATIONS, SHADOWS) => ({
    display: 'flex',
    flex_direction: 'row',
    column_gap: FOUNDATIONS.spacing_150,
    padding: `${FOUNDATIONS.spacing_300} ${FOUNDATIONS.spacing_250}`,
    width: '100%',
    height: '100%',
    border_radius: FOUNDATIONS.radius_comp_content_basiccard_radiussize,
    box_shadow: SHADOWS.shadow_100,
});
export const firstContainerCommonStyles = (FOUNDATIONS, FONT) => ({
    display: 'flex',
    flex_direction: 'column',
    width: '100%',
});
//# sourceMappingURL=commonStyles.js.map